import $ from 'jquery';

export default class MobileMenu {
  constructor () {
    $('[data-menu-toggle]').click(function (event) {
      event.preventDefault();

      const menu = $($(this).data('menu-toggle'));
      const activeClass = $(this).data('menu-toggle-class');

      menu.toggleClass(activeClass);

      $(this).toggleClass('menu-open');

      $('body').toggleClass('menu-open');
    });
  }
}
